import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import FocusTrap from '@s/FocusTrap';
import { getInitialFocusSelector } from '../../../helpers/helpers';
import { selectEventNameFromListingConfig } from 'checkout/selectors/ui';
import { TranslationContext } from '@c/Translations';

class TicketPickerContainer extends Component {
    componentDidMount = () => {
        window.scrollTo(0,0);
    }

    getContent = () => {
        return (
          <TranslationContext.Consumer>
            {({ t }) => (
              <dialog
                className={`tickets--as-overlay tickets-wrap ${this.props.isSeatingChart ? 'tickets-wrap--seating-chart' : ''}`}
                aria-modal="true"
                tabIndex="-1"
                aria-label={t('checkout__tickets_for_event', { event_name: this.props.eventName })}
              >
                  <div className="tickets">
                      {this.props.children}
                  </div>
              </dialog>
            )}
          </TranslationContext.Consumer>
        );
    }

    render() {
        if (!this.props.focusTrap) {
            return this.getContent();
        }
        return(
            <FocusTrap
                active={true}
                fallback = {'.tickets-wrap'}
                focusTrapOptions={{
                    initialFocus: getInitialFocusSelector('.ticket-action__add-button, .collapsible__button'),
                }}

            >
                {this.getContent()}
            </FocusTrap>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        eventName: selectEventNameFromListingConfig(state),
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

TicketPickerContainer.propTypes = {
    focusTrap: PropTypes.bool,
}

TicketPickerContainer.defaultProps = {
    focusTrap: true,
}

export default connect(mapStateToProps, mapDispatchToProps)(TicketPickerContainer)
